var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "px-6 py-6", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-stepper",
                {
                  staticClass: "bg-transparent overflow-visible w-100 mx-auto",
                  attrs: { "alt-labels": "", elevation: "0" },
                  model: {
                    value: _vm.e1,
                    callback: function ($$v) {
                      _vm.e1 = $$v
                    },
                    expression: "e1",
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mx-auto",
                          attrs: { lg: "8", cols: "12" },
                        },
                        [
                          _c(
                            "v-stepper-items",
                            {
                              staticClass:
                                "border-radius-xl overflow-hidden shadow-lg mt-5 mb-9",
                            },
                            [
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "1" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h3 text-center font-weight-normal my-2",
                                                  },
                                                  [_vm._v(" Try it Now ")]
                                                ),
                                              ]
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          { staticClass: "mt-2" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "10" } },
                                              [
                                                _c(
                                                  "v-container",
                                                  { attrs: { fluid: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        filled: "",
                                                        label: "Email",
                                                      },
                                                      model: {
                                                        value: _vm.email,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.email = $$v
                                                        },
                                                        expression: "email",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "text-end",
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-2 mb-2 me-2",
                                                            attrs: {
                                                              ripple: false,
                                                              elevation: 0,
                                                              block: "",
                                                              color: "primary",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.e1 = 2
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" Next ")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      { staticClass: "mt-3" },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "5",
                                                            },
                                                          },
                                                          [
                                                            _c("v-divider", {
                                                              staticClass:
                                                                "mt-3",
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "font-weight-bold",
                                                              },
                                                              [_vm._v("OR")]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "5",
                                                            },
                                                          },
                                                          [
                                                            _c("v-divider", {
                                                              staticClass:
                                                                "mt-3",
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      [
                                                        _c("v-col", {
                                                          attrs: { cols: "2" },
                                                        }),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "8",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    " Have an account? "
                                                                  ),
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        href: "#",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Log in"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs mt-10",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " By continuing, you agree to our Terms, Conditions, and Policies "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("v-col", {
                                                          attrs: { cols: "2" },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "2" },
                                },
                                [
                                  _c("v-card", { staticClass: "pt-8" }, [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "5" },
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    filled: "",
                                                    label: "First Name",
                                                  },
                                                  model: {
                                                    value: _vm.firstName,
                                                    callback: function ($$v) {
                                                      _vm.firstName = $$v
                                                    },
                                                    expression: "firstName",
                                                  },
                                                }),
                                                _c("v-text-field", {
                                                  attrs: {
                                                    filled: "",
                                                    label: "Last Name",
                                                  },
                                                  model: {
                                                    value: _vm.lastName,
                                                    callback: function ($$v) {
                                                      _vm.lastName = $$v
                                                    },
                                                    expression: "lastName",
                                                  },
                                                }),
                                                _c("v-text-field", {
                                                  attrs: {
                                                    filled: "",
                                                    label: "Email",
                                                  },
                                                  model: {
                                                    value: _vm.email,
                                                    callback: function ($$v) {
                                                      _vm.email = $$v
                                                    },
                                                    expression: "email",
                                                  },
                                                }),
                                                _c("v-text-field", {
                                                  attrs: {
                                                    filled: "",
                                                    label: "Phone Number",
                                                  },
                                                  model: {
                                                    value: _vm.phoneNumber,
                                                    callback: function ($$v) {
                                                      _vm.phoneNumber = $$v
                                                    },
                                                    expression: "phoneNumber",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mt-1",
                                                attrs: { cols: "5" },
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "font-weight-bolder",
                                                  },
                                                  [_vm._v(" Type of account: ")]
                                                ),
                                                _c(
                                                  "v-radio-group",
                                                  {
                                                    model: {
                                                      value: _vm.accountType,
                                                      callback: function ($$v) {
                                                        _vm.accountType = $$v
                                                      },
                                                      expression: "accountType",
                                                    },
                                                  },
                                                  [
                                                    _c("v-radio", {
                                                      attrs: {
                                                        label: "Individual",
                                                        value: "individual",
                                                        selected: "",
                                                      },
                                                    }),
                                                    _c("v-radio", {
                                                      attrs: {
                                                        label: "Company",
                                                        value: "company",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm.accountType === "company"
                                                  ? _c("v-text-field", {
                                                      attrs: {
                                                        filled: "",
                                                        label: "Company",
                                                      },
                                                      model: {
                                                        value: _vm.company,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.company = $$v
                                                        },
                                                        expression: "company",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 1
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 3
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "3" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What are your brand names? "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Be as comprehensive as you can if the name is used as a trademark, even for a specific product. "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-textarea", {
                                                  attrs: {
                                                    solo: "",
                                                    placeholder: "",
                                                    value: "",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 2
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 4
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "4" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What are the brand names you compete against? "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Be as comprehensive as you can if the name is used as a trademark, even for a specific product. "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-textarea", {
                                                  attrs: {
                                                    solo: "",
                                                    placeholder:
                                                      "Be as comprehensive as you can be, but you can always edit this selection later, so don't sweat it too much.",
                                                    value: "",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 3
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 5
                                              },
                                            },
                                          },
                                          [_vm._v(" Next ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                {
                                  staticClass:
                                    "bg-white border-radius-xl px-4 pt-4",
                                  attrs: { step: "5" },
                                },
                                [
                                  _c("v-card", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "text-left" },
                                          [
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mx-auto",
                                                attrs: { cols: "10" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "float-left my-1 mr-2",
                                                    attrs: {
                                                      large: "",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-information-outline "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "text-h4 font-weight-normal mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What's the Conversion Goal? "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-sm",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " What action do you want your ideal customer to take? "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-textarea", {
                                                  attrs: {
                                                    solo: "",
                                                    placeholder:
                                                      "What I want customers to do.  Here are some examples...\n˖  Request information with a form\n˖  Make a purchase\n˖  Call our office",
                                                    value: "",
                                                  },
                                                }),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold text-xs text-dark btn-light py-5 px-6 mt-6 mb-2 ms-2",
                                                    attrs: {
                                                      ripple: false,
                                                      elevation: 0,
                                                    },
                                                  },
                                                  [_vm._v(" Give Me Ideas * ")]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-body text-xs ml-3 font-italic",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " * Ideas are generated by AI "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-col", {
                                              attrs: { cols: "1" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex mt-10" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs text-dark btn-light bg-gradient-light py-5 px-6 mt-6 mb-2 ms-2",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.e1 = 4
                                              },
                                            },
                                          },
                                          [_vm._v(" Prev ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "font-weight-bold text-xs btn-default bg-gradient-default py-5 px-6 mt-6 mb-2 me-2 ms-auto",
                                            attrs: {
                                              ripple: false,
                                              elevation: 0,
                                              color: "primary",
                                            },
                                          },
                                          [_vm._v(" Finish ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }